module.exports = __webpack_public_path__ + "454289a0d0a40c459ca6c26b6cc34cb7.png";